<ui-confirmation-dialog
    header="time-tracking.payrollIntegrationPage.payrollIntegrationModal"
    primaryButtonLabel="close"
    #confirmPayrollIntegrationModal
>
    <p [innerHTML]="'time-tracking.payrollIntegrationPage.payrollIntegrationModalDescription' | translate"></p>
</ui-confirmation-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-header title="time-tracking.payrollIntegrationPage.title" [back]="true"></app-header>
    <ui-card>
        <p>{{ 'time-tracking.payrollIntegrationPage.transferWorkHours' | translate }}</p>
        <div class="app-grid margin-top-1">
            <mat-radio-group
                [ngModel]="settings.payrollIntegration"
                (ngModelChange)="onPayrollIntegrationRadioChange($event)"
                name="reminderCheckOptions"
                required
            >
                <mat-radio-button [value]="true" required>{{ 'yes' | translate }}</mat-radio-button>

                <mat-radio-button [value]="false" required>{{ 'no' | translate }}</mat-radio-button>
            </mat-radio-group>
        </div>
        <ng-container *ngIf="settings.payrollIntegration">
            <div class="margin-top-4 margin-bottom-3">
                <p>{{ 'time-tracking.payrollIntegrationPage.selectHourTypes' | translate }}</p>
                <ng-container *ngFor="let incomeType of incomeTypesToDisplay">
                    <div>
                        <mat-checkbox
                            [checked]="incomeType.enabled"
                            [value]="incomeType.id?.toString() ?? ''"
                            (change)="onIncomeTypeChange($event)"
                            [name]="incomeType.name"
                            type="checkbox"
                            [disabled]="incomeType.name === incomeTypesType.Regular"
                        >
                            {{ incomeType.displayName | translate }}
                        </mat-checkbox>
                    </div>
                </ng-container>
            </div>

            <ui-tip> {{ 'time-tracking.payrollIntegrationPage.tip' | translate }} </ui-tip>
        </ng-container>
    </ui-card>

    <!-- table showing employees on the payroll integration -->
    <ui-card *ngIf="settings.payrollIntegration">
        <p class="margin-bottom-2">{{ 'time-tracking.payrollIntegrationPage.tableExplanation' | translate }}</p>
        <app-assign-time-tracking-employees-to-payroll-integration-table
            [employees]="employeesOnPayrollIntegration"
            (onEmployeesChange)="onEmployeeIntegrationsChange($event)"
        ></app-assign-time-tracking-employees-to-payroll-integration-table>
    </ui-card>

    <div class="flex buttons justify-end">
        <ui-button (click)="onCancel()" type="ghost">{{ 'cancel' | translate }}</ui-button>
        <ui-button (click)="onSave()" type="primary">{{ 'save' | translate }}</ui-button>
    </div>
</div>
